import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ToastContainer } from "react-toastify";
import moment from "moment";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/styles.scss";
import "react-toastify/dist/ReactToastify.min.css";
import "animate.css/animate.min.css";
// import "bootstrap/dist/css/bootstrap.css";
// import "./assets/scss/paper-dashboard.scss";
// import "./assets/demo/demo.css";
// import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

import { changeLanguage, getLanguage } from "./utils/utils";
import { GET_JWT, USER_DEFAULT_LANGUAGE } from "./constants";
// eslint-disable-next-line
import { es } from "moment/locale/es";
import "./i18n";
import App from "./App";

if (getLanguage() === "es") {
  moment.locale("es");
} else {
  moment.locale("en");
}

if (localStorage.getItem(USER_DEFAULT_LANGUAGE)) {
  changeLanguage(localStorage.getItem(USER_DEFAULT_LANGUAGE));
} else {
  changeLanguage("en");
}

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_BACKEND_PROTOCOL || "http"}://${process.env
    .REACT_APP_GRAPHQL_SERVER || "localhost:4000"}`,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = GET_JWT();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    dataIdFromObject: (object) => object.id || null,
  }),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={true}
      pauseOnHover
      closeOnClick
    />
    <App />
  </ApolloProvider>,
  document.getElementById("root")
);
